import React from 'react';
import { TRIP_TYPES } from '@/lib/cabServices';

const BAR_LABELS = {
  one_way: 'One Way',
  round_trip: 'Round Trip',
  local_rental: 'Local Rental',
  airport_transfer: 'Airport',
};

const HERO_ICONS = {
  one_way: '🚗',
  round_trip: '↔',
  local_rental: '📍',
  airport_transfer: '✈',
};

const TripTypeSelector = ({ value, onChange, variant = 'default' }) => {
  const isBar = variant === 'bar';
  const isHero = variant === 'hero';

  if (isHero) {
    return (
      <div className="flex gap-1.5 mb-4 pb-4 border-b border-gray-100 overflow-x-auto" data-testid="trip-type-selector">
        {TRIP_TYPES.map((trip) => {
          const selected = value === trip.id;
          const label = BAR_LABELS[trip.id] || trip.label;
          return (
            <button
              key={trip.id}
              type="button"
              onClick={() => onChange(trip.id)}
              className={`px-4 py-2 rounded-xl text-sm font-semibold whitespace-nowrap border-none cursor-pointer font-[inherit] transition-all duration-150 ${
                selected
                  ? 'bg-[#1B2D5E] text-white'
                  : 'bg-transparent text-gray-400 hover:bg-gray-50'
              }`}
              data-testid={`trip-type-${trip.id}`}
            >
              {HERO_ICONS[trip.id] || trip.icon} {label}
            </button>
          );
        })}
      </div>
    );
  }

  if (isBar) {
    return (
      <div className="flex justify-center mb-4" data-testid="trip-type-selector">
        <div
          className="inline-flex flex-wrap gap-1"
          style={{
            background: '#EFEFEF',
            borderRadius: '10px',
            padding: '4px',
          }}
        >
          {TRIP_TYPES.map((trip) => {
            const selected = value === trip.id;
            const label = BAR_LABELS[trip.id] || trip.label;
            return (
              <button
                key={trip.id}
                type="button"
                onClick={() => onChange(trip.id)}
                className="font-body transition-colors whitespace-nowrap"
                style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  padding: '9px 18px',
                  borderRadius: '8px',
                  background: selected ? '#1B2D5E' : 'transparent',
                  color: selected ? 'white' : '#555',
                  border: 'none',
                  cursor: 'pointer',
                }}
                data-testid={`trip-type-${trip.id}`}
              >
                {label}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex flex-wrap gap-1.5 p-1 rounded-[10px] bg-[#F0F0F0]"
      data-testid="trip-type-selector"
    >
      {TRIP_TYPES.map((trip) => {
        const selected = value === trip.id;
        return (
          <button
            key={trip.id}
            type="button"
            onClick={() => onChange(trip.id)}
            className={`flex-1 min-w-[calc(50%-6px)] sm:min-w-0 sm:flex-initial px-5 py-2.5 rounded-lg font-body text-sm font-medium transition-colors ${
              selected
                ? 'bg-[#1B2D5E] text-white'
                : 'bg-[#F5F5F5] text-[#555555] border border-[#E0E0E0] hover:bg-white'
            }`}
            data-testid={`trip-type-${trip.id}`}
          >
            {trip.label}
          </button>
        );
      })}
    </div>
  );
};

export default TripTypeSelector;
